export const environment = {
  production: false,
  gtmTrackingId: 'GTM-523BNZ9',
  contentfulParams: {
    space: '6euw9nkwzdou',
    accessToken: 'zkkPRcXCv0R3fDb3JW626CvW3ss4a59iPEH8DK-jyR0',
    previewToken: 'Cg-TN9hvknfmhGj7u0SkgXgAPS17WdiCnHxVYtSmZLY',
    environment: 'master',
  }
};
